import { Component, ViewEncapsulation, Input, ViewChild, Injectable, ViewChildren, ElementRef, ContentChildren, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { B2CMobileDrawerPresetHeightEnum, B2CMobileDrawerModule } from 'b2c-ui/mobile-drawer';
import { CommonModule } from '@angular/common';
import { NzDrawerModule, NzButtonModule } from 'ng-zorro-antd';
import { I18nModule } from 'b2c-ui/i18n';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { B2CNgzIconModule } from 'b2c-ui/ngz-icons';

/**
 * @fileoverview added by tsickle
 * Generated from: component/b2c-mobile-select-option.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'b2c-ui/mobile-drawer';
import * as ɵngcc2 from 'ng-zorro-antd/radio';
import * as ɵngcc3 from '@angular/forms';
import * as ɵngcc4 from '@angular/common';
import * as ɵngcc5 from 'ng-zorro-antd';

const _c0 = ["content"];
function B2CMobileSelectOptionComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c1 = ["*"];
const _c2 = ["labelComponents"];
function B2CMobileSelectComponent_label_2_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileSelectComponent_label_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CMobileSelectComponent_label_2_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", item_r4 == null ? null : item_r4.template);
} }
function B2CMobileSelectComponent_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 9, 10);
    ɵngcc0.ɵɵtemplate(2, B2CMobileSelectComponent_label_2_ng_container_2_Template, 2, 1, "ng-container", 11);
    ɵngcc0.ɵɵelement(3, "label", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r4 == null ? null : item_r4.template);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("nzValue", item_r4 == null ? null : item_r4.value);
} }
function B2CMobileSelectComponent_ng_container_7_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c3 = function (a0) { return { selected: a0 }; };
function B2CMobileSelectComponent_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CMobileSelectComponent_ng_container_7_ng_container_1_Template, 1, 0, "ng-container", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.selectedTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c3, ctx_r1.selected));
} }
function B2CMobileSelectComponent_ng_template_8_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function B2CMobileSelectComponent_ng_template_8_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, B2CMobileSelectComponent_ng_template_8_ng_container_0_ng_container_1_Template, 1, 0, "ng-container", 13);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r10.placeholder);
} }
function B2CMobileSelectComponent_ng_template_8_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r12.placeholder, " ");
} }
function B2CMobileSelectComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, B2CMobileSelectComponent_ng_template_8_ng_container_0_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(1, B2CMobileSelectComponent_ng_template_8_ng_template_1_Template, 1, 1, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r11 = ɵngcc0.ɵɵreference(2);
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isTemplate(ctx_r3.placeholder))("ngIfElse", _r11);
} }
const _c4 = function (a0) { return { "width": a0 }; };
class B2CMobileSelectOptionComponent {
}
B2CMobileSelectOptionComponent.ɵfac = function B2CMobileSelectOptionComponent_Factory(t) { return new (t || B2CMobileSelectOptionComponent)(); };
B2CMobileSelectOptionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CMobileSelectOptionComponent, selectors: [["b2c-mobile-select-option"]], viewQuery: function B2CMobileSelectOptionComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.content = _t.first);
    } }, inputs: { value: "value", label: "label" }, ngContentSelectors: _c1, decls: 2, vars: 0, consts: [["content", ""]], template: function B2CMobileSelectOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, B2CMobileSelectOptionComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
    } }, encapsulation: 2 });
B2CMobileSelectOptionComponent.propDecorators = {
    value: [{ type: Input }],
    label: [{ type: Input }],
    content: [{ type: ViewChild, args: ['content', { static: false },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CMobileSelectOptionComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-mobile-select-option',
                encapsulation: ViewEncapsulation.None,
                template: `
    <ng-template #content>
      <ng-content></ng-content>
    </ng-template>
  `
            }]
    }], null, { value: [{
            type: Input
        }], label: [{
            type: Input
        }], content: [{
            type: ViewChild,
            args: ['content', { static: false }]
        }] }); })();
if (false) {
    /** @type {?} */
    B2CMobileSelectOptionComponent.prototype.value;
    /** @type {?} */
    B2CMobileSelectOptionComponent.prototype.label;
    /** @type {?} */
    B2CMobileSelectOptionComponent.prototype.content;
}

/**
 * @fileoverview added by tsickle
 * Generated from: service/b2c-selection.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CSelectionService {
    /**
     * @param {?} components
     * @return {?}
     */
    buildSelections(components) {
        return components.map((/**
         * @param {?} __0
         * @return {?}
         */
        ({ value, content, label }) => {
            return {
                value,
                template: content,
                label
            };
        }));
    }
    /**
     * @param {?} selected
     * @param {?} selections
     * @param {?} renderedList
     * @param {?} single
     * @param {?} multi
     * @return {?}
     */
    findSelected(selected, selections, renderedList, single, multi) {
        /** @type {?} */
        const cloned = selections.slice();
        /** @type {?} */
        let foundIndex;
        /** @type {?} */
        let found;
        if (single) {
            found = cloned.find((/**
             * @param {?} __0
             * @param {?} index
             * @return {?}
             */
            ({ value }, index) => {
                if (typeof value === 'object') {
                    /** @type {?} */
                    let equal = true;
                    Object.keys(value).forEach((/**
                     * @param {?} key
                     * @return {?}
                     */
                    (key) => {
                        if (value[key] !== selected[key]) {
                            equal = false;
                        }
                    }));
                    return equal;
                }
                if (selected === value) {
                    foundIndex = index;
                    return true;
                }
                return false;
            }));
        }
        if (multi) {
        }
        /** @type {?} */
        const render = renderedList.find((/**
         * @param {?} _
         * @param {?} index
         * @return {?}
         */
        (_, index) => foundIndex === index));
        if (render) {
            /** @type {?} */
            const text = render.nativeElement.textContent;
            return Object.assign({}, found, { textContent: text ? text.trim() : undefined });
        }
        return found;
    }
}
B2CSelectionService.ɵfac = function B2CSelectionService_Factory(t) { return new (t || B2CSelectionService)(); };
B2CSelectionService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: B2CSelectionService, factory: B2CSelectionService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CSelectionService, [{
        type: Injectable
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: container/b2c-mobile-select.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CMobileSelectComponent {
    /**
     * @param {?} selectionService
     */
    constructor(selectionService) {
        this.selectionService = selectionService;
        this.transparent = false;
        this.single = false;
        this.multiple = false;
        this.showButtons = false;
        this.height = B2CMobileDrawerPresetHeightEnum.HALF;
        this.propagateChange = true;
        this.disabled = false;
        this.showDrawer = false;
        this.selections = [];
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.selections = this.selectionService.buildSelections(this.components);
        if (this.pending) {
            this.selected = this.selections.find((/**
             * @param {?} __0
             * @return {?}
             */
            ({ value }) => {
                if (typeof this.pending === 'object') {
                    /** @type {?} */
                    let equal = true;
                    Object.keys(this.pending).forEach((/**
                     * @param {?} key
                     * @return {?}
                     */
                    (key) => {
                        if (this.pending[key] !== value[key]) {
                            equal = false;
                        }
                    }));
                    return equal;
                }
                return value === this.pending;
            }));
        }
    }
    /**
     * @param {?} evt
     * @return {?}
     */
    handleChange(evt) {
        if (this.onTouchFn) {
            this.onTouchFn();
        }
        if (this.onChangeFn) {
            this.onChangeFn(evt);
        }
        this.selected = this.selectionService.findSelected(evt, this.selections, this.labelComponents, true, false);
    }
    /**
     * @param {?} variable
     * @return {?}
     */
    isTemplate(variable) {
        return typeof variable !== 'string';
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouchFn = fn;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        if (this.selections && this.selections.length > 0) {
        }
        this.pending = value;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
}
B2CMobileSelectComponent.ɵfac = function B2CMobileSelectComponent_Factory(t) { return new (t || B2CMobileSelectComponent)(ɵngcc0.ɵɵdirectiveInject(B2CSelectionService)); };
B2CMobileSelectComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: B2CMobileSelectComponent, selectors: [["b2c-mobile-select"]], contentQueries: function B2CMobileSelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, B2CMobileSelectOptionComponent, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.components = _t);
    } }, viewQuery: function B2CMobileSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c2, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.labelComponents = _t);
    } }, inputs: { transparent: "transparent", single: "single", multiple: "multiple", showButtons: "showButtons", height: "height", propagateChange: "propagateChange", title: "title", placeholder: "placeholder", selectedTemplate: "selectedTemplate", width: "width" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: B2CMobileSelectComponent,
                multi: true
            },
            B2CSelectionService
        ])], ngContentSelectors: _c1, decls: 12, vars: 13, consts: [[3, "show", "title", "height", "hideButtons"], [1, "w-100", 3, "ngModel", "ngModelChange"], ["class", "b2c-mobile-select-option w-100 py-3 pointer", 4, "ngFor", "ngForOf"], [1, "d-none"], [1, "b2c-mobile-select", "pointer", "p-2", "align-middle", "text-black", "d-flex", "justify-content-between", "align-items-center", 3, "ngClass", "ngStyle", "click"], [1, "placeholder"], [4, "ngIf", "ngIfElse"], ["defaultTemplate", ""], ["nz-icon", "", "nzTheme", "outline", 3, "nzType"], [1, "b2c-mobile-select-option", "w-100", "py-3", "pointer"], ["labelComponents", ""], [4, "ngIf"], ["nz-radio", "", 1, "mr-0", 3, "nzValue"], [4, "ngTemplateOutlet"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["placeHolderTemplate", ""]], template: function B2CMobileSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "b2c-mobile-drawer", 0);
        ɵngcc0.ɵɵelementStart(1, "nz-radio-group", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function B2CMobileSelectComponent_Template_nz_radio_group_ngModelChange_1_listener($event) { ctx.handleChange($event); return ctx.showDrawer = false; })("ngModelChange", function B2CMobileSelectComponent_Template_nz_radio_group_ngModelChange_1_listener($event) { return ctx.radioValue = $event; });
        ɵngcc0.ɵɵtemplate(2, B2CMobileSelectComponent_label_2_Template, 4, 2, "label", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 4);
        ɵngcc0.ɵɵlistener("click", function B2CMobileSelectComponent_Template_div_click_5_listener() { return ctx.showDrawer = true; });
        ɵngcc0.ɵɵelementStart(6, "span", 5);
        ɵngcc0.ɵɵtemplate(7, B2CMobileSelectComponent_ng_container_7_Template, 2, 4, "ng-container", 6);
        ɵngcc0.ɵɵtemplate(8, B2CMobileSelectComponent_ng_template_8_Template, 3, 2, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "span");
        ɵngcc0.ɵɵelement(11, "i", 8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(9);
        ɵngcc0.ɵɵproperty("show", ctx.showDrawer)("title", ctx.title)("height", ctx.height)("hideButtons", !ctx.showButtons);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngModel", ctx.radioValue);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.selections);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngClass", ctx.transparent ? "" : "border rounded")("ngStyle", ɵngcc0.ɵɵpureFunction1(11, _c4, ctx.width));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.selected)("ngIfElse", _r2);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("nzType", ctx.showDrawer ? "up" : "down");
    } }, directives: [ɵngcc1.B2CMobileDrawerComponent, ɵngcc2.NzRadioGroupComponent, ɵngcc3.NgControlStatus, ɵngcc3.NgModel, ɵngcc4.NgForOf, ɵngcc4.NgClass, ɵngcc4.NgStyle, ɵngcc4.NgIf, ɵngcc5.NzIconDirective, ɵngcc2.NzRadioComponent, ɵngcc4.NgTemplateOutlet], encapsulation: 2 });
/** @nocollapse */
B2CMobileSelectComponent.ctorParameters = () => [
    { type: B2CSelectionService }
];
B2CMobileSelectComponent.propDecorators = {
    title: [{ type: Input }],
    placeholder: [{ type: Input }],
    selectedTemplate: [{ type: Input }],
    transparent: [{ type: Input }],
    single: [{ type: Input }],
    multiple: [{ type: Input }],
    showButtons: [{ type: Input }],
    height: [{ type: Input }],
    propagateChange: [{ type: Input }],
    width: [{ type: Input }],
    labelComponents: [{ type: ViewChildren, args: ['labelComponents', { read: ElementRef },] }],
    components: [{ type: ContentChildren, args: [B2CMobileSelectOptionComponent, { descendants: true },] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CMobileSelectComponent, [{
        type: Component,
        args: [{
                selector: 'b2c-mobile-select',
                template: "<b2c-mobile-drawer [show]=\"showDrawer\" [title]=\"title\" [height]=\"height\" [hideButtons]=\"!showButtons\">\r\n  <nz-radio-group class=\"w-100\" (ngModelChange)=\"handleChange($event); showDrawer = false;\" [(ngModel)]=\"radioValue\">\r\n    <label class=\"b2c-mobile-select-option w-100 py-3 pointer\" *ngFor=\"let item of selections\" #labelComponents>\r\n      <ng-container *ngIf=\"item?.template\">\r\n        <ng-container *ngTemplateOutlet=\"item?.template\"></ng-container>\r\n      </ng-container>\r\n      <label nz-radio class=\"mr-0\" [nzValue]=\"item?.value\"></label>\r\n    </label>\r\n  </nz-radio-group>\r\n</b2c-mobile-drawer>\r\n\r\n<div class=\"d-none\">\r\n  <ng-content></ng-content>\r\n</div>\r\n\r\n<div [ngClass]=\"transparent ? '' : 'border rounded'\" [ngStyle]=\"{'width': width}\"\r\n  class=\"b2c-mobile-select pointer p-2 align-middle text-black d-flex justify-content-between align-items-center\" \r\n  (click)=\"showDrawer = true;\">\r\n  <span class=\"placeholder\">\r\n    <ng-container *ngIf=\"selected; else defaultTemplate\">\r\n      <ng-container *ngTemplateOutlet=\"selectedTemplate; context: { selected: selected }\"></ng-container>\r\n    </ng-container>\r\n    <ng-template #defaultTemplate>\r\n      <ng-container *ngIf=\"isTemplate(placeholder); else placeHolderTemplate\">\r\n        <ng-container *ngTemplateOutlet=\"placeholder\"></ng-container>\r\n      </ng-container>\r\n      <ng-template #placeHolderTemplate>\r\n        {{ placeholder }}\r\n      </ng-template>\r\n    </ng-template>\r\n  </span>\r\n  <span>\r\n    <i nz-icon [nzType]=\"showDrawer ? 'up' : 'down'\" nzTheme=\"outline\"></i>\r\n  </span>\r\n</div>",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: B2CMobileSelectComponent,
                        multi: true
                    },
                    B2CSelectionService
                ]
            }]
    }], function () { return [{ type: B2CSelectionService }]; }, { transparent: [{
            type: Input
        }], single: [{
            type: Input
        }], multiple: [{
            type: Input
        }], showButtons: [{
            type: Input
        }], height: [{
            type: Input
        }], propagateChange: [{
            type: Input
        }], title: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], selectedTemplate: [{
            type: Input
        }], width: [{
            type: Input
        }], labelComponents: [{
            type: ViewChildren,
            args: ['labelComponents', { read: ElementRef }]
        }], components: [{
            type: ContentChildren,
            args: [B2CMobileSelectOptionComponent, { descendants: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    B2CMobileSelectComponent.prototype.title;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.placeholder;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.selectedTemplate;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.transparent;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.single;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.multiple;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.showButtons;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.height;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.propagateChange;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.width;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.radioValue;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.disabled;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.showDrawer;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.selected;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.labelComponents;
    /** @type {?} */
    B2CMobileSelectComponent.prototype.components;
    /**
     * @type {?}
     * @private
     */
    B2CMobileSelectComponent.prototype.selections;
    /**
     * @type {?}
     * @private
     */
    B2CMobileSelectComponent.prototype.onTouchFn;
    /**
     * @type {?}
     * @private
     */
    B2CMobileSelectComponent.prototype.onChangeFn;
    /**
     * @type {?}
     * @private
     */
    B2CMobileSelectComponent.prototype.pending;
    /**
     * @type {?}
     * @private
     */
    B2CMobileSelectComponent.prototype.selectionService;
}

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-mobile-select.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class B2CMobileSelectModule {
}
B2CMobileSelectModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: B2CMobileSelectModule });
B2CMobileSelectModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function B2CMobileSelectModule_Factory(t) { return new (t || B2CMobileSelectModule)(); }, imports: [[
            CommonModule,
            NzDrawerModule,
            NzButtonModule,
            I18nModule,
            NzCheckboxModule,
            NzRadioModule,
            B2CMobileDrawerModule,
            FormsModule,
            ReactiveFormsModule,
            B2CNgzIconModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(B2CMobileSelectModule, { declarations: function () { return [B2CMobileSelectComponent,
        B2CMobileSelectOptionComponent]; }, imports: function () { return [CommonModule,
        NzDrawerModule,
        NzButtonModule,
        I18nModule,
        NzCheckboxModule,
        NzRadioModule,
        B2CMobileDrawerModule,
        FormsModule,
        ReactiveFormsModule,
        B2CNgzIconModule]; }, exports: function () { return [B2CMobileSelectComponent,
        B2CMobileSelectOptionComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(B2CMobileSelectModule, [{
        type: NgModule,
        args: [{
                declarations: [B2CMobileSelectComponent, B2CMobileSelectOptionComponent],
                exports: [B2CMobileSelectComponent, B2CMobileSelectOptionComponent],
                imports: [
                    CommonModule,
                    NzDrawerModule,
                    NzButtonModule,
                    I18nModule,
                    NzCheckboxModule,
                    NzRadioModule,
                    B2CMobileDrawerModule,
                    FormsModule,
                    ReactiveFormsModule,
                    B2CNgzIconModule
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: b2c-ui-mobile-select.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { B2CMobileSelectComponent, B2CMobileSelectModule, B2CMobileSelectOptionComponent, B2CSelectionService };


//# sourceMappingURL=b2c-ui-mobile-select.js.map